import React from 'react';

import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from './style';

export function BackToList({ link, name }) {
  return (
    <Grid>
      <Button component={Link} to={link} variant="contained" size="small">
        {`< ${name}`}
      </Button>
    </Grid>
  );
}

BackToList.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string,
};
BackToList.defaultProps = {
  name: 'Back to list',
};
